import { type ReactElement } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  type CheckboxProps,
} from "@mui/material";
import { useField } from "formik";

import type { MakeRequired } from "utils/types";

type FormikCheckboxProps = {
  label: string | ReactElement;
  helperText?: string | ReactElement;
} & MakeRequired<CheckboxProps, "name">;

const FormikCheckbox = ({
  name,
  label,
  helperText,
  ...rest
}: FormikCheckboxProps) => {
  const [field] = useField<unknown>(name);

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox checked={Boolean(field.value)} {...field} {...rest} />
        }
        label={label}
        sx={{ mb: 0 }}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </>
  );
};

export default FormikCheckbox;
